const directiveFiles = require.context('./', true, /\.js$/)

// directives/index.ts
export default {
    install(app) {
        const directiveFiles = require.context('./', true, /\.js$/)

        directiveFiles.keys().forEach((path) => {
            if (!path.includes('index')) {
                const moduleName = path.replace(/^\.\/(.*)\.\w+$/, '$1')
                const directive = directiveFiles(path).default
                app.directive(moduleName, directive)
            }
        })
    }
}
